import { useTranslation } from "react-i18next";

type ITrailerProps = { trailer: any };

export default function TrailerCard({ trailer }: ITrailerProps) {
  const { t } = useTranslation();

  return (
    <div className="rounded-lg bg-white/[0.04] px-6 ">
      <div className="grid grid-cols-6 border-b border-primary py-4">
        <img
          src="/assets/icons/shipper/dl.svg"
          alt="phone"
          className="my-auto"
        ></img>
        <div className="col-span-5">
          <p className="text-blue/[0.5] text-sm uppercase">
            {t("trailers_page.trailer_number")}
          </p>
          <p>{trailer?.number || "N/A"}</p>
        </div>
      </div>
    </div>
  );
}
